import { useState } from 'react';
import { recordDraw as recordDrawApi } from '../api/commissions';
import type { RecordDrawRequest } from '../types/commission';

/**
 * Hook for recording a draw (advance payment) for an estimator
 */
export function useRecordDraw() {
  const [isLoading, setIsLoading] = useState(false);

  const recordDraw = async (request: RecordDrawRequest): Promise<boolean> => {
    setIsLoading(true);
    try {
      await recordDrawApi(request);
      return true;
    } catch (error) {
      console.error('Record draw error:', error);
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  return { recordDraw, isLoading };
}
